import { mainApi } from 'services/mainApi'

export const locationApi = mainApi
    .enhanceEndpoints({
        addTagTypes:[`LocationTips`]
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            readLocationTips: builder.query({
                query: () => {
                    let url = `/locations`
                    return url
                },
                providesTags: (result, error, arg) => ['LocationTips'],  
            }),   
            deleteLocationsTips: builder.mutation({
                query: () => ({
                    url: `locations`,
                    method: 'DELETE',      
                }),
                invalidatesTags: ['LocationTips']
            })
    }),
})

export const {
    useReadLocationTipsQuery,
    useDeleteLocationsTipsMutation
} = locationApi
